// FLAGS: legacy
// The single Redux store, still load-bearing: `authReducers` inside it is where the browser's `isLoggedIn`
// answer lives. Frontend rules forbid Redux in new code — read from React Query or context instead.
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import combineReducers from "./reducers";

const middleware = [thunk];

const store = createStore(
  combineReducers,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
